import { makeStyles } from "@mui/styles";

import { middleGray } from "../../../../constants/colors";

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
    backgroundColor: "rgb(246 246 246 / 88%)",
  },
  messageItem: {
    textDecoration: "none",
    backgroundColor: "#fff",
    borderRadius: "0.25rem",
    flexDirection: "column",
    fontFamily: "SanFrancisco",
    fontSize: "1.25rem",
    margin: 0,
    padding: 0,
    "&:hover": {
      "& $showMoreOptions": {
        visibility: "visible",
        color: "white",
        right: " 0%",
        transform: "translateX(0%)",
      },
    },
  },
  flexDisplay: { display: "flex" },
  blockDisplay: { display: "block" },
  userMsgBody: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  customerMsgBody: {
    backgroundColor: middleGray,
    "&::after": {
      borderColor: `transparent ${middleGray} transparent transparent`,
    },
  },
  safeHtml: {
    "&  a": {
      textDecoration: "none",
      color: theme.palette.white.main,
    },
    marginRight: "10px !important",
  },
  body: {
    fontFamily: "SFProText-Regular",
    fontSize: "16px",
  },
  status: {
    display: "block",
    fontSize: "10px",
    color: theme.palette.secondary.main,
  },
  time: {
    fontFamily: "SFProText-Regular",
    fontSize: "12px",
    color: "rgb(0 0 0 / 45%)",
    textAlign: "right",
    bottom: "0",
    alignSelf: "flex-end",
  },
  date: {
    fontFamily: "SFProText-Regular",
    fontSize: "16px",
    textAlign: "center",
    padding: "3px 10px",
    borderRadius: "3px",
    margin: "0 auto",
    backgroundColor: theme.palette.GroupsTableHeaderBgColor,
    textTransform: "uppercase",
    marginTop: "2%",
    color: theme.palette.mainText,
    width: "24%",
  },
  messageInfo: {
    textAlign: "center",
    backgroundColor: "#e0f3fa",
    boxShadow: "0 1px .5px rgba(var(--shadow-rgb),.13)",
    width: "fit-content",
    padding: "4px 10px",
    borderRadius: "3px",
    margin: "0 auto",
    color: "rgb(0 0 0 / 88%)",
    marginTop: "2%",
  },
  media: {
    // width: 200,
    width: "100%",
    height: 200,
    marginRight: "10px !important",
    objectFit: "cover",
  },
  showMoreOptions: {
    textAlign: "center",
    width: "fit-content",
    height: "fit-content",
    padding: 0,
    margin: 0,
    display: " inline-block",
    position: "relative",
    right: "-100%",
    transform: "translateX(-100%)",
    transition: "right .03s, transform .03s",
    visibility: "hidden",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  forwardedDiv: {
    display: "flex",
    alignItems: "center",
  },
  forwardedLabel: {
    fontFamily: "SFProText-Regular",
    fontSize: "12px",
    color: "#848484",
  },
  messageContent: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  optionsFormControl: {
    margin: theme.spacing(1),
  },
  VoteButton: {
    margin: theme.spacing(1, 1, 0, 0),
  },
  optionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: theme.palette.primary.main,
  },
  newMessagesTextContainer: {
    width: "100%",
    textAlign: "center",
    backgroundColor: theme.palette.bg,
  },
  newMessagesText: {
    position: "relative",
    top: "10px",
    background: "#fff",
    display: "inline-block",
    padding: "0 20px",
    backgroundColor: theme.palette.bg,
    color: theme.palette.secondary.main,
  },
  line: {
    height: "1px",
    background: "#bdbdbd",
  },
  groupMessageSender: {
    padding: 0,
    paddingLeft: "10px",
    margin: 0,
    color: "#bababa",
    fontFamily: "SFProText-Regular",
    fontSize: "14px",
  },
  avatar: {
    position: "relative",
    width: "fit-content",
    float: "left",
    display: "flex",
    // right: "10px",
    marginRight: "10px",
  },
  docFile: {
    display: "flex",
    justifyContent: "start-flex",
    alignItems: "center",
    textDecoration: "none",
    color: "black",
    backgroundColor: "white",
    padding: "7px 14px",
    borderRadius: "10px",
  },
  ul: {
    margin: 0,
    padding: 0,
  },
  form: {
    margin: 0,
    padding: 0,
  },
  input: {
    margin: 0,
    padding: 0,
  },
  userMessageContent: {
    alignSelf: "flex-end",
    backgroundColor: "#34C759",
    color: "#fff",
    position: "relative",
    "&::after": {
      backgroundColor: theme.palette.bg,
      borderBottomLeftRadius: "0.5rem",
      right: "-40px",
      transform: "translate(-30px, -2px)",
      width: "10px",
      content: '""',
      position: "absolute",
      bottom: "-0.1rem",
      height: "1rem",
    },
    "&::before": {
      borderBottomLeftRadius: "0.8rem 0.7rem",
      borderRight: "1rem solid #34C759",
      right: "-0.35rem",
      transform: "translate(0, -0.1rem)",
      content: '""',
      position: "absolute",
      bottom: "-0.1rem",
      height: "1rem",
    },
  },
  userMessageBody: {
    borderRadius: "1.15rem",
    lineHeight: 1.25,
    width: "fit-content",
    maxWidth: "500px",
    padding: "0.5rem .875rem",
    position: "relative",
    wordWrap: "break-word",
    alignSelf: "flex-end",
    backgroundColor: "#34C759",
    color: "#fff",
    "&::after": {
      backgroundColor: theme.palette.bg,
      borderBottomLeftRadius: "0.5rem",
      right: "-40px",
      transform: "translate(-30px, -2px)",
      width: "10px",
      content: '""',
      position: "absolute",
      bottom: "-0.1rem",
      height: "1rem",
    },
    "&::before": {
      borderBottomLeftRadius: "0.8rem 0.7rem",
      borderRight: "1rem solid #34C759",
      right: "-0.35rem",
      transform: "translate(0, -0.1rem)",
      content: '""',
      position: "absolute",
      bottom: "-0.1rem",
      height: "1rem",
    },
  },
  customerMessageBody: {
    borderRadius: "1.15rem",
    lineHeight: 1.25,
    width: "fit-content",
    padding: "0.5rem .875rem",
    position: "relative",
    wordWrap: "break-word",
    alignItems: "flex-start",
    backgroundColor: theme.palette.msgColor,
    color: "#000",
    "&::before": {
      borderBottomRightRadius: "0.8rem 0.7rem",
      borderLeft: `1rem solid ${theme.palette.msgColor}`,
      left: "-0.35rem",
      transform: "translate(0, -0.1rem)",
      content: '""',
      position: "absolute",
      bottom: "-0.1rem",
      height: "1rem",
    },
    "&::after": {
      backgroundColor: theme.palette.bg,
      borderBottomRightRadius: "0.5rem",
      left: "20px",
      transform: "translate(-30px, -2px)",
      width: "10px",
      content: '""',
      position: "absolute",
      bottom: "-0.1rem",
      height: "1rem",
    },
  },
  customerMessageBodyGreenColor: {
    backgroundColor: "#34C759 !important",
    color: "white",
    "&::before": {
      borderBottomRightRadius: "0.8rem 0.7rem",
      borderLeft: "1rem solid #34C759",
      left: "-0.35rem",
      transform: "translate(0, -0.1rem)",
      content: '""',
      position: "absolute",
      bottom: "-0.1rem",
      height: "1rem",
    },
  },
  greenBackground: {
    backgroundColor: "red !important",
  },
  messageContent: {
    // add any general message content styles here if needed
  },
  link: {
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

export default useStyles;
